<div class="EFShowcaseView">
    @if (isLoading) {
        <app-pg-loading [isLarge]="true" [isOverlay]="true"></app-pg-loading>
    }
    @if (!isLoading) {
        <app-ef-showcase [showcaseContent]="showcaseContent" [realmId]="realmId" [showQR]="showcaseWithQR"></app-ef-showcase>
    }
</div>